import {Component, Input} from '@angular/core';
import {Project} from '../model/project';
import {Questionnaire} from '../model/questionnaire';

@Component({
  selector:'file-chooser-list-element',
  template:`

      <td><div><div style="float:left"><span><i style="color:#8e8e8e;font-size: 20px;" (click)="toggle()" [ngClass]="project.isSelected ? 'fas fa-caret-down' : 'fas fa-caret-right'" ></i></span></div><div style="float:left; padding-left: 5px;"><span><i style="color:#81d8fd;font-size:20px;" class="fas fa-folder"></i></span></div></div><div style="padding-left:35px;">{{project.name}}</div></td>

    <tr *ngFor="let quest of getQuestionnaireList()">
      <td style="padding-left: 20px;"><span><i style="font-size: 20px; color:#00b0ff;" class="far fa-file-code"></i></span><div style="padding-left:35px;">{{quest.src}}</div></td>
    </tr>
  `,
  styles:[`
    tr{width: 100%}
    tr:nth-child(even){background-color: #ffffff}
  tr:nth-last-child(odd){background-color: #f5f5f5}`]
})


export class FileChooserListElementComponent {

  @Input('project') project:Project;

  private exploded =false;

  constructor() {}

  private getQuestionnaireList():Questionnaire[] {
      if(this.exploded) {
        return this.project.questionnaires;
      }
      return [];
  }

  toggle() {
    this.exploded = !this.exploded;
  }
}
